var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.6914 37V26.2656H18V22H21.6914V18.6391C21.6914 14.9875 23.9824 13 27.3273 13C28.9299 13 30.3064 13.1172 30.7059 13.1687V16.9844H28.3861C26.5668 16.9844 26.2155 17.8281 26.2155 19.0609V22H30.3209L29.7578 26.2656H26.2155V37","fill":"currentColor"}));
}

FacebookInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
